import { gloablSensorTableColumns } from "../../../Common/constants";
import SensorListTable from "./SensorListTable";

const Sensor = () => {

    return (
        <div className="sensor-list-container mt-3">
            <SensorListTable columns={gloablSensorTableColumns} />
        </div>
    )
}

export default Sensor;